export class Login {
    async get_cached_login() {
        const refresh = localStorage.getItem("refresh");
        if (refresh) {
            return await this.refresh_login(refresh);
        }
        return false;
    }
    async refresh_login(refresh_token) {
        const response = await fetch("https://api.95b0db3eec.net/refresh", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ refresh_token })
        });
        const ans = await response.json();
        if (response.status == 200) {
            this.auth = {
                AccessToken: ans.AccessToken,
                IdToken: ans.IdToken,
                RefreshToken: refresh_token
            };
            return true;
        }
        else {
            this.auth = undefined;
            return false;
        }
    }
    async login_with_password(password) {
        const response = await fetch("https://api.95b0db3eec.net/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ password })
        });
        const ans = await response.json();
        if (response.status == 200) {
            this.auth = {
                AccessToken: ans.AccessToken,
                IdToken: ans.IdToken,
                RefreshToken: ans.RefreshToken,
            };
            this.store_refresh_token(ans.RefreshToken);
            return true;
        }
        else {
            this.auth = undefined;
            return false;
        }
    }
    store_refresh_token(token) {
        localStorage.setItem("refresh", token);
    }
}
//# sourceMappingURL=login.js.map